import React, { Component } from 'react'
import { observer } from 'mobx-react'
import mainStore from '@components/Main/store'
import CommonRightModal from '../CommonRightModal'

@observer
export default class extends Component {
  render() {
    const {
      rightFloatVisible,
      rightFloatPoster: { image_path },
      gotoRightFloat,
      closeRightFloat
    } = mainStore.posterStore

    return (
      <CommonRightModal
        visible={rightFloatVisible}
        imagePath={image_path}
        goTo={gotoRightFloat}
        close={closeRightFloat}
      />
    )
  }
}
